import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { LoginForm } from "./components/auth/LoginForm";
import { SignupUserForm } from "./components/auth/SignupUserForm";
import { SignupRoleSelection } from "./components/auth/SignupRoleSelection";
import ProtectedRoute from "./components/common/ProtectedRoute";

import { useEffect } from "react";
import axios from "axios";
import { auth } from "./config/firebase"; // Import Firebase auth
import { FactorAuth } from "./components/auth/2FactoreAuth";
import OtpVerification from "./components/auth/OtpVerification";
import Mobile2FactoreVerification from "./components/auth/mobile2Factor";
import ForgotPassword from "./components/auth/ForgotPassword";
import EmailSend from "./components/auth/EmailSend";
import CreatePassword from "./components/auth/CreatePassoword";
import { DirectoryComponents } from "./pages/Admin/directory";
import { ActivityComponents } from "./pages/Admin/activity";
import { SignupExpertForm } from "./components/auth/SignUpExpertForm";
import Setting from "./common/setting/setting";
import Admindashboard from "./pages/Admin/adminDashboard/Admindashboard";
import { NotificationComponents } from "./common/notification/notification";
import { AdminNotification } from "./pages/Admin/notification/AdminNotification";
import { UserProfile } from "./common/profile/profile";
import ExpertActivity from "./pages/Expert/Activity";
import Payment from "./common/payment";
import CustomerDashboard from "./pages/Customer/dashboard";
import CustomerAcitivity from "./pages/Customer/Activity";
import ExpertDashboard from "./pages/Expert/dashboard";
import Tooltip from "./pages/Admin/tooltip";
import AdminPayment from "./pages/Admin/payment";
import PasswordResetSuccess from "./components/auth/PasswordSuccess";
import VideoCallPage from "./pages/VideoCallPage";
import TooltipExpert from "./pages/Expert/Tooltip/Tooltip";
import TooltipCustomer from "./pages/Customer/Tooltip/Tooltip";
import Teams from "./pages/Expert/teams/TeamsExpert";
import TeamsCustomer from "./pages/Customer/Teams/TeamsCustomer";

import { SignupBySubscription } from "./components/auth/RegisterBySubscription";
import { useAppState } from "./hooks/useAppState";
import FundRequest from "./components/fund/FundRequest";
import AdminTeams from "./pages/Admin/teams/AdminTeams";
// Import Redux Provider and store
import { useDispatch } from "react-redux";
import { AppDispatch } from "./store";
import {
  fetchAllTeamData,
  setupTeamRealtimeListeners,
  cleanupTeamRealtimeListeners,
} from "./store/slices/teamSlice";

const functionUrl = `https://us-central1-supporty-staging.cloudfunctions.net/createCustomToken`; // Replace with your function URL

// Create an AppContent component that will use hooks inside Provider
function App() {
  const {  isAuthenticated } = useAppState();
  const {user} = useAppState();
  const dispatch = useDispatch<AppDispatch>();
  // const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user") || "{}") : null
  const navigate = useNavigate(); // Enable navigation
console.log(user,"user")
  const sendCustomTokenToExtension = async (
    firebaseUser: any,
    newUser: boolean
  ) => {
    try {
      const response = await axios.post(functionUrl, { uid: firebaseUser.uid });
      const customToken = response.data.customToken;
      if (typeof chrome !== "undefined" && chrome.runtime) {
        chrome.runtime.sendMessage(
          "ndcmfkbjobahmdpjakmgnomklohgalfc", // Replace with your Chrome extension ID
          { type: "LOGIN", token: customToken, user: firebaseUser, newUser }, // Ensure the message structure is correct
          (response: { success: boolean; message: string }) => {
            if (chrome.runtime.lastError) {
              console.error(
                "Error sending message to Chrome extension:",
                chrome.runtime.lastError.message
              );
            } else if (response.success) {
              console.log("Response from Chrome extension:", response.message);
            } else {
              console.error("Error from Chrome extension:", response.message);
            }
          }
        );
        chrome.runtime.sendMessage(
          "hedjogelnmjoilmlomnekfbchmbfngja", // Replace with your Chrome extension ID
          { type: "LOGIN", token: customToken, user: firebaseUser, newUser }, // Ensure the message structure is correct
          (response: { success: boolean; message: string }) => {
            if (chrome.runtime.lastError) {
              console.error(
                "Error sending message to Chrome extension:",
                chrome.runtime.lastError.message
              );
            } else if (response.success) {
              console.log("Response from Chrome extension:", response.message);
            } else {
              console.error("Error from Chrome extension:", response.message);
            }
          }
        );
      } else {
        console.error("chrome.runtime is not available.");
      }
    } catch (error) {
      console.error("Error generating custom token:", error);
    }
  };

  // Background fetch team data when user is authenticated
  useEffect(() => {
    if (isAuthenticated && user?.uid && user?.orgId && user?.teamId) {
      console.log('App.tsx: Fetching team data in background', { 
        orgId: user.orgId, 
        teamId: user.teamId, 
        uid: user.uid,
        role: user?.teamRole || user?.uiRole 
      });
      
      // Fetch all team data in background
      dispatch(
        fetchAllTeamData({
          orgId: user.orgId,
          userId: user.teamId, // Pass teamId as userId for fetching team data
          currentId: user.uid,
          userRole: user?.teamRole || user?.uiRole || "",
        })
      );

      // Setup real-time listeners for continuous updates
      dispatch(
        setupTeamRealtimeListeners({
          orgId: user.orgId,
          userId: user.teamId, // Pass teamId for proper team listener setup
          currentId: user.uid,
          userRole: user?.teamRole || user?.uiRole || "",
        })
      );

      // Cleanup on unmount or user change
      return () => {
        dispatch(cleanupTeamRealtimeListeners());
      };
    }
  }, [isAuthenticated, user?.uid, user?.orgId, user?.teamId, user?.role, user?.uiRole, user?.teamRole, dispatch]);

  useEffect(() => {


    const checkLoginStatus = async () => {
      if (typeof chrome !== "undefined" && chrome.runtime) {
        chrome.runtime.sendMessage(
          "ndcmfkbjobahmdpjakmgnomklohgalfc", // Replace with your Chrome extension ID
          { type: "CHECK_LOGIN" },
          async (response: { success: boolean; message: string }) => {
            if (chrome.runtime.lastError) {
              console.error(
                "Error sending message to Chrome extension:",
                chrome.runtime.lastError.message
              );
            } else if (response.success) {
              console.log("User is logged in:", response.message);
            } else {
              console.error("User is not logged in:", response.message);

              const firebaseUser = auth.currentUser;
              if (firebaseUser) {
                await sendCustomTokenToExtension(firebaseUser, false);
              } else {
                // Handle logout or navigation to sign-in page
                console.log(
                  "No user logged in. Redirecting to sign-in page..."
                );
                // navigate("/signin");
              }
            }
          }
        );
         chrome.runtime.sendMessage(
          "hedjogelnmjoilmlomnekfbchmbfngja", // Replace with your Chrome extension ID
          { type: "CHECK_LOGIN" },
          async (response: { success: boolean; message: string }) => {
            if (chrome.runtime.lastError) {
              console.error(
                "Error sending message to Chrome extension:",
                chrome.runtime.lastError.message
              );
            } else if (response.success) {
              console.log("User is logged in:", response.message);
            } else {
              console.error("User is not logged in:", response.message);

              const firebaseUser = auth.currentUser;
              if (firebaseUser) {
                await sendCustomTokenToExtension(firebaseUser, false);
              } else {
                // Handle logout or navigation to sign-in page
                console.log(
                  "No user logged in. Redirecting to sign-in page..."
                );
                // navigate("/signin");
              }
            }
          }
        );
        chrome.runtime.sendMessage(
          "hedjogelnmjoilmlomnekfbchmbfngja", // Replace with your Chrome extension ID
          { type: "LOGOUT" },
          (response) => {
            if (chrome.runtime.lastError) {
              console.error(
                "Error sending logout message to Chrome extension:",
                chrome.runtime.lastError.message
              );
            } else if (response?.success) {
              console.log(
                "Chrome extension logout response:",
                response.message
              );
            } else {
              
              console.error("Error from Chrome extension:", response?.message);
            }
          }
        );
         chrome.runtime.sendMessage(
          "ndcmfkbjobahmdpjakmgnomklohgalfc", // Replace with your Chrome extension ID
          { type: "LOGOUT" },
          (response) => {
            if (chrome.runtime.lastError) {
              console.error(
                "Error sending logout message to Chrome extension:",
                chrome.runtime.lastError.message
              );
            } else if (response?.success) {
              console.log(
                "Chrome extension logout response:",
                response.message
              );
            } else {
              
              console.error("Error from Chrome extension:", response?.message);
            }
          }
        );
      } else {
        console.error("chrome.runtime is not available.");
      }
    };

    checkLoginStatus();
  }, [isAuthenticated, user, navigate]);

  // Helper to determine default route based on user role
  const getDefaultRoute = () => {
    if (!user?.role) return "/signin";
    switch (user?.role) {
      case "supporty_admin":
        return "/admin/dashboard";
      case "Expert":
        return "/expert/dashboard";
      case "Customer":
        return "/user/dashboard";
      default:
        return "/signin";
    }
  };

  return (
    <div className=" bg-gray-50">
      <main className={`${isAuthenticated ? " mx-auto pl-4" : ""}`}>
        <Routes>
          {/* Public routes */}
          <Route
            path="/signin"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <LoginForm />
              )
            }
          />
          {/* <Route
            path="/signup"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <SignupRoleSelection />
              )
            }
          /> */}
          <Route
            path="/signup/user"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <SignupUserForm />
              )
            }
          />
          <Route
            path="/signup/expert"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <SignupExpertForm />
              )
            }
          />
          <Route
            path="/signup/admin"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <SignupExpertForm />
              )
            }
          />
          <Route
            path="/complete-registration"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <SignupBySubscription />
              )
            }
          />
          <Route
            path="/fund-requests"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <FundRequest />
              )
            }
          />
          <Route
            path="/signup/2FA"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <FactorAuth />
              )
            }
          />
          <Route path="/signup/otp-verify" element={<OtpVerification />} />
          <Route
            path="/signup/mobile-otp-verify"
            element={<Mobile2FactoreVerification />}
          />
          <Route
            path="/forgot-passoword"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <ForgotPassword />
              )
            }
          />
          <Route
            path="/email-send"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <EmailSend />
              )
            }
          />
          <Route
            path="/create-password"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <CreatePassword />
              )
            }
          />
          <Route
            path="/password-success"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <PasswordResetSuccess />
              )
            }
          />
          <Route path="/video-call/:roomId" element={<VideoCallPage />} />
          {/* Admin Routes */}
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Navigate to={getDefaultRoute()} />
              ) : (
                <Navigate to="/signin" />
              )
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute
                allowed={["supporty_admin"]}
                element={<Admindashboard />}
              />
            }
          />
          <Route
            path="/admin/activity"
            element={
              <ProtectedRoute
                allowed={["supporty_admin"]}
                element={<ActivityComponents />}
              />
            }
          />
          <Route
            path="/admin/directory"
            element={
              <ProtectedRoute
                allowed={["supporty_admin"]}
                element={<DirectoryComponents />}
              />
            }
          />
          <Route
            path="/admin/teams"
            element={
              <ProtectedRoute
                allowed={["supporty_admin"]}
                element={<AdminTeams />}
              />
            }
          />
          <Route
            path="/admin/payment"
            element={
              <ProtectedRoute
                allowed={["supporty_admin"]}
                element={<AdminPayment />}
              />
            }
          />
          <Route
            path="/admin/tooltip"
            element={
              <ProtectedRoute
                allowed={["supporty_admin"]}
                element={<Tooltip />}
              />
            }
          />
          <Route
            path="/admin/profile"
            element={
              <ProtectedRoute
                allowed={["supporty_admin"]}
                element={<UserProfile />}
              />
            }
          />{" "}
          <Route
            path="/admin/notification"
            element={
              <ProtectedRoute
                allowed={["supporty_admin"]}
                element={<AdminNotification />}
              />
            }
          />
          <Route
            path="/admin/setting"
            element={
              <ProtectedRoute
                allowed={["supporty_admin"]}
                element={<Setting />}
              />
            }
          />
          {/* Expert Routes */}
          <Route
            path="/expert/dashboard"
            element={
              <ProtectedRoute
                allowed={["Expert"]}
                element={<ExpertDashboard />}
              />
            }
          />
          <Route
            path="/expert/activity"
            element={
              <ProtectedRoute
                allowed={["Expert"]}
                element={<ExpertActivity />}
              />
            }
          />
          <Route
            path="/expert/tooltip"
            element={
              <ProtectedRoute
                allowed={["Expert"]}
                element={<TooltipExpert />}
              />
            }
          />
          <Route
            path="/expert/teams"
            element={
              <ProtectedRoute allowed={["Expert"]} element={<Teams />} />
            }
          />
          <Route
            path="/expert/tooltips"
            element={
              <ProtectedRoute allowed={["Expert"]} element={< TooltipExpert/>} />
            }
          />
          <Route
            path="/expert/profile"
            element={
              <ProtectedRoute allowed={["Expert"]} element={<UserProfile />} />
            }
          />
          <Route
            path="/expert/notification"
            element={
              <ProtectedRoute
                allowed={["Expert"]}
                element={<NotificationComponents />}
              />
            }
          />
          <Route
            path="/expert/setting"
            element={
              <ProtectedRoute allowed={["Expert"]} element={<Setting />} />
            }
          />
          {/* Customer Routes */}
          <Route
            path="/user/dashboard"
            element={
              <ProtectedRoute
                allowed={["Customer"]}
                element={<CustomerDashboard />}
              />
            }
          />
          <Route
            path="/user/activity"
            element={
              <ProtectedRoute
                allowed={["Customer"]}
                element={<CustomerAcitivity />}
              />
            }
          />
          <Route
            path="/user/teams"
            element={
              <ProtectedRoute
                allowed={["Customer"]}
                element={<TeamsCustomer />}
              />
            }
          />
          <Route
            path="/user/tooltip"
            element={
              <ProtectedRoute
                allowed={["Customer"]}
                element={<TooltipCustomer />}
              />
            }
          />
          <Route
            path="/user/payment"
            element={
              <ProtectedRoute allowed={["Customer"]} element={<Payment />} />
            }
          />
          <Route
            path="/user/profile"
            element={
              <ProtectedRoute
                allowed={["Customer"]}
                element={<UserProfile />}
              />
            }
          />
          <Route
            path="/user/notification"
            element={
              <ProtectedRoute
                allowed={["Customer"]}
                element={<NotificationComponents />}
              />
            }
          />
          <Route
            path="/user/setting"
            element={
              <ProtectedRoute allowed={["Customer"]} element={<Setting />} />
            }
          />
          {/* Catch-all route */}
          <Route
            path="*"
            element={
              <Navigate to={isAuthenticated ? getDefaultRoute() : "/signin"} />
            }
          />
        </Routes>
      </main>
    </div>
  );
}

export default App;
